import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import HomeComponent from "@/components/Home/HomeComponent";
import Head from "next/head";

export default function Home() {
    return (
        <div>
            <Head>
                <title>Bzaaarz Partner</title>
            </Head>

            <HomeComponent />
        </div>
    );
}

export const getServerSideProps = async ({ locale }: any) => ({
    props: {
        ...(await serverSideTranslations(locale, ["common"])),
    },
});
